import React, {useState, Fragment} from 'react'
import {useDispatch} from "react-redux"
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

// Material-UI
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// custom Component
import DocSubSearchResultTable from './DocSubSearchResultTable'

// Custom Style
import {docSubSearchFormStyle} from '../../styles/jss/components/documentSubmission/docSubSearchFormStyle'


// Custom Style (Typography)
const ResultMsgTypography = withStyles({
	root: {
		"fontSize": 15,
		"fontWeight": 600,
		"color": "red",
	},
}) (Typography)


const useStyles = makeStyles(theme => docSubSearchFormStyle(theme))

const DocSubSearchForm = props => {
	const {submissionType, submissionStage, searchLoading, searchMsg, submissionSearchAction, searchResult, docSubDetailDialogHandleOpen} = props
	const classes = useStyles()
	const dispatch = useDispatch()
	
	const [searchProperty, setSearchProperty] = useState({
		type_seq: "",
		stage_seq: "",
		keywords: "",
		createdate_start: null,
		createdate_end: null
	})


	const handleTextChange = event => {
		const {name, value} = event.target
		const newSearchProperty = {...searchProperty}
		newSearchProperty[name] = value
		setSearchProperty(newSearchProperty)

		dispatch({
			type: "ADD_DOCUMENT_SUBMISSION_SEARCH_PROPERTY",
			data: newSearchProperty
		})
	}

	const handleSelectChange = event => {
		const {name, value} = event.target
		const newSearchProperty = {...searchProperty}
		newSearchProperty[name] = value
		setSearchProperty(newSearchProperty)

		dispatch({
			type: "ADD_DOCUMENT_SUBMISSION_SEARCH_PROPERTY",
			data: newSearchProperty
		})
	}

	const handleCreateDateStartChange = (date) => {
		const newSearchProperty = {...searchProperty}
		newSearchProperty.createdate_start = date
		setSearchProperty(newSearchProperty)

		dispatch({
			type: "ADD_DOCUMENT_SUBMISSION_SEARCH_PROPERTY",
			data: newSearchProperty
		})
	}

	const handleCreateDateEndChange = (date) => {
		const newSearchProperty = {...searchProperty}
		newSearchProperty.createdate_end = date
		setSearchProperty(newSearchProperty)

		dispatch({
			type: "ADD_DOCUMENT_SUBMISSION_SEARCH_PROPERTY",
			data: newSearchProperty
		})
	}


	return (
		<Fragment>
			<form className={classes.root} noValidate autoComplete="off">

				<TextField
					id="keywords" 
					name="keywords" 
					label="Key Word" 
					type="text" 
					fullWidth={true} 
					size="small" 
					variant="outlined" 
					value={searchProperty.keywords || ""}
					onChange={handleTextChange} 
				/>

				<Grid container justify="space-between">
					<TextField
						select
						id="type_seq"
						name="type_seq"
						label="Document Type"
						// fullWidth={true}
						size="small"
						variant="outlined"
						value={searchProperty.type_seq || ""}
						onChange={handleSelectChange}
						className={classes.searchField}
					>
						<MenuItem key={"init"} value={""} selected><em>None</em></MenuItem>
						{
							submissionType.map(res => 
								(<MenuItem key={res.type_seq} value={res.type_seq}>{res.type_name}</MenuItem>)
							)
						}
					</TextField>

					<TextField
						select
						id="stage_seq"
						name="stage_seq"
						label="Document Stage"
						// fullWidth={true}
						size="small"
						variant="outlined"
						value={searchProperty.stage_seq || ""}
						onChange={handleSelectChange}
						className={classes.searchField}
					>
						<MenuItem key={"init"} value={""} selected><em>None</em></MenuItem>
						{
							submissionStage.map(res => 
								(<MenuItem key={res.stage_seq} value={res.stage_seq}>{res.stage_name}</MenuItem>)
							)
						}
					</TextField>
				</Grid>

				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<Grid container justify="space-between">
						<KeyboardDatePicker
							id="submission_start"
							name="submission_start"
							label="Date (From)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							value={searchProperty.createdate_start || null}
							onChange={handleCreateDateStartChange}
							className={classes.datePickerField}
						/>
					
						<KeyboardDatePicker
							id="submission_end"
							name="submission_end"
							label="Date (To)"
							format="dd/MM/yyyy"
							inputVariant="outlined"
							placeholder="DD/MM/YYYY"
							size="small"
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							value={searchProperty.createdate_end || null}
							onChange={handleCreateDateEndChange}
							className={classes.datePickerField}
						/>
					</Grid>
				</MuiPickersUtilsProvider>

				<Box className={classes.searchBtn}>
					<Button variant="contained" color="primary" onClick={submissionSearchAction}>
						Search
					</Button>
				</Box>
			</form>

			{searchLoading}
			{
				searchResult && searchResult.length > 0 ?
					<DocSubSearchResultTable 
						searchResult={searchResult}
						docSubDetailDialogHandleOpen={docSubDetailDialogHandleOpen}
					/>
				: <div className={classes.resultMsg}><ResultMsgTypography>{searchMsg}</ResultMsgTypography></div>
			}
					
		</Fragment>
	)
}


export default DocSubSearchForm